module.exports = __webpack_public_path__ + "5c44c4a069aa3bcffb4910c0f11d1c5a.jpg";